import { useState } from 'react';
import { HiringSettingsAlerts } from './HiringSettingsAlerts.jsx';
import { HiringSettingsQuestions } from './HiringSettingsQuestions.jsx';
import { HiringSettingsReferrals } from './HiringSettingsReferrals.jsx';
import { HiringSettingsSignals } from './HiringSettingsSignals.jsx';
import { HiringSettingsPositions } from './HiringSettingsPositions.jsx';

// ─── Hiring settings (Settings → Hiring) ─────────────────────────────────
// Hiring v3 / Ticket B5 + D1 — Two panels:
//   1. Alert recipients per café (Ticket B5)
//   2. Interview question pool admin (Ticket D1)
//   3. Referrals, hiring signals
//   4. Positions & rates — the advertised wage, editable (CJ 2026-09-11)
export function HiringSettingsView({ currentUser, locations }) {
  const [section, setSection] = useState('alerts');
  return (
    <div>
      <div style={{ display: 'flex', gap: 6, marginBottom: 12, flexWrap: 'wrap' }}>
        {[
          ['alerts', 'Alert recipients'],
          ['questions', 'Interview questions'],
          ['referrals', 'Referrals'],
          ['signals', 'Hiring signals'],
          ['positions', 'Positions & rates'],
        ].map(([id, label]) => (
          <button key={id} onClick={() => setSection(id)}
            style={{ border: '1px solid #d0d4d9', borderRadius: 8, padding: '6px 14px',
                      fontSize: 13, fontWeight: 600,
                      background: section === id ? 'var(--gold)' : '#fff',
                      color: section === id ? '#fff' : '#333', cursor: 'pointer' }}>
            {label}
          </button>
        ))}
      </div>
      {section === 'alerts'    && <HiringSettingsAlerts currentUser={currentUser} locations={locations} />}
      {section === 'questions' && <HiringSettingsQuestions currentUser={currentUser} />}
      {section === 'referrals' && <HiringSettingsReferrals currentUser={currentUser} />}
      {section === 'signals'   && <HiringSettingsSignals currentUser={currentUser} />}
      {section === 'positions' && <HiringSettingsPositions currentUser={currentUser} />}
    </div>
  );
}
